import React from 'react';
import PropTypes from 'prop-types';
import { Button, buttonTypes } from 'moods-react/Button';
import TickSuccessIcon from '../icons/tick-success/TickSuccessComponent';
import LoadingIcon from '../icons/loading/LoadingComponent';

import './ProgressiveButton.scss';

/**
 * Common Moo style Button that can be extended for async requests
 */
// TODO: refactor for onClick usage with MOODS-react button component & investigate async req
class ProgressiveButtonComponent extends React.Component {
  constructor(props) {
    super(props);
    this.click = this.click.bind(this);
  }

  click() {
    if (!this.props.isDisabled) {
      this.props.onClick();
    }
  }

  render() {
    const { loading, success, icon, isDisabled, isFullWidth, type } = this.props;
    const buttonActive = !loading && !success;
    const loadingActive = !isDisabled && !success && loading;
    const successActive = !isDisabled && success && !loading;

    const buttonActiveClass = buttonActive ? 'progressive-button-component__button--active' : '';
    const loadingActiveClass = loadingActive ? 'progressive-button-component__loading--active' : '';
    const successActiveClass = successActive ? 'progressive-button-component__success--active' : '';
    const buttonDisabledClass = isDisabled ? 'progressive-button-component--disabled' : '';

    return (
      <div
        className={`progressive-button-component progressive-button-component--${type} ${buttonDisabledClass}`}
        onClick={this.click}
      >
        <div className={`progressive-button-component__button ${buttonActiveClass}`}>
          <Button onClick={() => {}} type={type} icon={icon} isDisabled={isDisabled} isFullWidth={isFullWidth}>
            {this.props.text}
          </Button>
        </div>
        <div className={`progressive-button-component__loading ${loadingActiveClass}`}>
          <span className="progressive-button-component__loader">
            <LoadingIcon />
          </span>
        </div>
        <div className={`progressive-button-component__success ${successActiveClass}`}>
          <TickSuccessIcon />
        </div>
      </div>
    );
  }
}

ProgressiveButtonComponent.displayName = 'ProgressiveButton';

ProgressiveButtonComponent.propTypes = {
  loading: PropTypes.bool,
  success: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
  text: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  icon: PropTypes.element,
};
ProgressiveButtonComponent.defaultProps = {
  onClick: () => null,
  loading: false,
  success: false,
  isDisabled: false,
};

ProgressiveButtonComponent.TYPES = buttonTypes;

export default ProgressiveButtonComponent;
